/**
 * The form's base URL as a path, with a single trailing slash and no query string.
 *
 * Every URL the form builds — '/submit', '/upload', '/step-2/' — is appended to
 * `apiBaseUrl`, so anything after a '?' or '#' has to come off first. Page links
 * carry '?stage=Stage' in draft mode, which would otherwise swallow the segment and
 * give '.../quarterly-report-form/?stage=Stage/step-1/'.
 *
 * The current query string is not lost by dropping it here: the browser keeps the one
 * it is already on, and useStepUrl carries it across when it rewrites the URL.
 */
export function formBasePath(apiBaseUrl: string | undefined): string {
  return (apiBaseUrl || '/').replace(/[?#].*$/, '').replace(/\/*$/, '/');
}

/**
 * Joins a path onto the form's base URL, e.g. 'submit' -> '/.../quarterly-report-form/submit'.
 */
export function formUrl(apiBaseUrl: string | undefined, path: string): string {
  return formBasePath(apiBaseUrl) + path.replace(/^\/+/, '');
}
